// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from 'react';

const TEAM_MEMBERS = [
  { name: 'Ryan Miskulin', role: 'CEO / Founder', personal: 'rmiskulin@gmail.com', company: 'R.miskulin@miskulintechnologies.com', ndaRequired: false },
  { name: 'Jordan Lutz', role: 'Lead Developer', personal: 'criodtech@gmail.com', company: 'J.lutz@miskulintechnologies.com', ndaRequired: true },
  { name: 'Tyler Hodgson', role: 'Developer', personal: 'tyler.hodgson32@gmail.com', company: 'T.hodgson@miskulintechnologies.com', ndaRequired: true },
  { name: 'Taylor Schenher', role: 'Developer', personal: '', company: 'T.schenher@miskulintechnologies.com', ndaRequired: true },
  { name: 'Jesse Falk', role: 'American Ambassador', personal: 'threewayindustries@gmail.com', company: '', ndaRequired: true },
  { name: 'Des Bachynski', role: 'Canadian Ambassador', personal: 'desbachynski@gmail.com', company: 'D.bachynski@miskulintechnologies.com', ndaRequired: true },
  { name: 'Lucas Mason', role: 'Canadian Ambassador', personal: 'lucas.s.mason@gmail.com', company: 'L.mason@miskulintechnologies.com', ndaRequired: true },
  { name: 'Lee Mehling', role: 'American Ambassador', personal: 'leemehling@hotmail.com', company: 'L.mehling@miskulintechnologies.com', ndaRequired: true },
  { name: 'Crystal Lutz', role: 'Admin', personal: 'cloricer77@gmail.com', company: 'C.robertson@miskulintechnologies.com', ndaRequired: true },
  { name: 'Tyson Becker', role: 'Canadian Ambassador', personal: 'tyson@canstorr.com', company: 'T.becker@miskulintechnologies.com', ndaRequired: true },
  { name: 'Jordan Hansen', role: 'American Ambassador', personal: 'jhansen860@yahoo.com', company: 'J.hansen@miskulintechnologies.com', ndaRequired: true },
  { name: 'Derek Little', role: 'Canadian Ambassador', personal: 'littlesderek@gmail.com', company: 'D.little@miskulintechnologies.com', ndaRequired: true },
  { name: 'Laken Weston', role: 'Canadian Ambassador', personal: 'laken.weston@live.ca', company: 'L.weston@miskulintechnologies.com', ndaRequired: true },
  { name: 'Che LeBlanc', role: 'Canadian Ambassador', personal: 'che@rosebudcannabisfarms.ca', company: 'C.leblanc@miskulintechnologies.com', ndaRequired: true },
  { name: 'Shanon Lutz', role: 'Social Media', personal: 'shanon@lanewaymedia.ca', company: 'S.lutz@miskulintechnologies.com', ndaRequired: true },
  { name: 'Amanda Henwood', role: 'Canadian Ambassador', personal: 'amandakristaleigh@hotmail.com', company: 'A.henwood@miskulintechnologies.com', ndaRequired: true },
  { name: 'Harold Blahut', role: 'IOD Founder', personal: '', company: 'H.blahut@miskulintechnologies.com', ndaRequired: true },
  { name: 'Darren Blahut', role: 'IOD Operations', personal: 'dblahut@sastel.net', company: 'D.blahut@miskulintechnologies.com', ndaRequired: true },
  { name: 'Al Benesocky', role: 'Advisor', personal: '', company: 'A.benesocky@miskulintechnologies.com', ndaRequired: true },
];

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#0f172a',
    color: '#f1f5f9',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    padding: '32px 24px',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  header: {
    textAlign: 'center',
    marginBottom: '32px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    color: '#f1f5f9',
    margin: '0 0 8px 0',
  },
  subtitle: {
    fontSize: '16px',
    color: '#94a3b8',
    margin: '0',
    fontWeight: '400',
  },
  statsBar: {
    display: 'flex',
    gap: '16px',
    marginBottom: '32px',
    flexWrap: 'wrap',
  },
  statCard: {
    flex: '1 1 200px',
    backgroundColor: '#1e293b',
    border: '1px solid #334155',
    borderRadius: '12px',
    padding: '20px 24px',
    textAlign: 'center',
  },
  statLabel: {
    fontSize: '13px',
    color: '#94a3b8',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    margin: '0 0 8px 0',
  },
  statValue: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#4F46E5',
    margin: '0',
  },
  statValueGreen: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#22c55e',
    margin: '0',
  },
  tableCard: {
    backgroundColor: '#1e293b',
    border: '1px solid #334155',
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '32px',
  },
  tableHeader: {
    padding: '20px 24px',
    borderBottom: '1px solid #334155',
  },
  tableTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#f1f5f9',
    margin: '0',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    textAlign: 'left',
    padding: '12px 16px',
    fontSize: '12px',
    fontWeight: '600',
    color: '#94a3b8',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: '1px solid #334155',
    backgroundColor: '#1e293b',
  },
  td: {
    padding: '12px 16px',
    fontSize: '14px',
    color: '#f1f5f9',
    borderBottom: '1px solid #334155',
  },
  tdMuted: {
    padding: '12px 16px',
    fontSize: '14px',
    color: '#64748b',
    borderBottom: '1px solid #334155',
    fontStyle: 'italic',
  },
  rowEven: {
    backgroundColor: '#1e293b',
  },
  rowOdd: {
    backgroundColor: '#172033',
  },
  badgeRequired: {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: '9999px',
    fontSize: '12px',
    fontWeight: '600',
    backgroundColor: 'rgba(34, 197, 94, 0.15)',
    color: '#22c55e',
    border: '1px solid rgba(34, 197, 94, 0.3)',
  },
  badgeNA: {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: '9999px',
    fontSize: '12px',
    fontWeight: '600',
    backgroundColor: 'rgba(148, 163, 184, 0.15)',
    color: '#94a3b8',
    border: '1px solid rgba(148, 163, 184, 0.3)',
  },
  infoSection: {
    backgroundColor: '#1e293b',
    border: '1px solid #334155',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px',
  },
  infoTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#f1f5f9',
    margin: '0 0 16px 0',
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '16px',
  },
  infoItem: {
    backgroundColor: '#0f172a',
    border: '1px solid #334155',
    borderRadius: '8px',
    padding: '16px',
  },
  infoItemLabel: {
    fontSize: '12px',
    fontWeight: '600',
    color: '#4F46E5',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    margin: '0 0 6px 0',
  },
  infoItemValue: {
    fontSize: '14px',
    color: '#cbd5e1',
    margin: '0',
    lineHeight: '1.5',
  },
  howItWorksSection: {
    backgroundColor: '#1e293b',
    border: '1px solid #334155',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '32px',
  },
  stepList: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  stepItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },
  stepNumber: {
    flexShrink: '0',
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    backgroundColor: '#4F46E5',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: '700',
  },
  stepText: {
    fontSize: '14px',
    color: '#cbd5e1',
    lineHeight: '1.6',
    paddingTop: '3px',
  },
  stepTextBold: {
    color: '#f1f5f9',
    fontWeight: '600',
  },
  footer: {
    textAlign: 'center',
    padding: '24px 0',
    borderTop: '1px solid #334155',
    marginTop: '16px',
  },
  footerText: {
    fontSize: '13px',
    color: '#64748b',
    margin: '0',
  },
};

function NDATrackerPage() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredMembers = TEAM_MEMBERS.filter(member =>
    member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    member.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
    member.personal.toLowerCase().includes(searchTerm.toLowerCase()) ||
    member.company.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalMembers = TEAM_MEMBERS.length;
  const ndasRequired = TEAM_MEMBERS.filter(m => m.ndaRequired).length;

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        {/* Header */}
        <div style={styles.header}>
          <h1 style={styles.title}>NDA Compliance Tracker</h1>
          <p style={styles.subtitle}>Mt Forge — Team NDA Status</p>
        </div>

        {/* Stats Bar */}
        <div style={styles.statsBar}>
          <div style={styles.statCard}>
            <p style={styles.statLabel}>Total Team Members</p>
            <p style={styles.statValue}>{totalMembers}</p>
          </div>
          <div style={styles.statCard}>
            <p style={styles.statLabel}>NDAs Required</p>
            <p style={styles.statValueGreen}>{ndasRequired}</p>
          </div>
          <div style={styles.statCard}>
            <p style={styles.statLabel}>NDA System Status</p>
            <p style={styles.statValueGreen}>Active</p>
          </div>
        </div>

        {/* Search */}
        <div style={{ marginBottom: '16px' }}>
          <input
            type="text"
            placeholder="Search team members..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              backgroundColor: '#1e293b',
              border: '1px solid #334155',
              borderRadius: '8px',
              color: '#f1f5f9',
              fontSize: '14px',
              outline: 'none',
              boxSizing: 'border-box',
            }}
          />
        </div>

        {/* Team Members Table */}
        <div style={styles.tableCard}>
          <div style={styles.tableHeader}>
            <h2 style={styles.tableTitle}>Team Members</h2>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>#</th>
                  <th style={styles.th}>Name</th>
                  <th style={styles.th}>Role</th>
                  <th style={styles.th}>Personal Email</th>
                  <th style={styles.th}>Company Email</th>
                  <th style={styles.th}>NDA Required</th>
                </tr>
              </thead>
              <tbody>
                {filteredMembers.map((member, index) => (
                  <tr key={member.name} style={index % 2 === 0 ? styles.rowEven : styles.rowOdd}>
                    <td style={styles.td}>{index + 1}</td>
                    <td style={{ ...styles.td, fontWeight: '600' }}>{member.name}</td>
                    <td style={styles.td}>{member.role}</td>
                    <td style={member.personal ? styles.td : styles.tdMuted}>
                      {member.personal || 'Not provided'}
                    </td>
                    <td style={member.company ? styles.td : styles.tdMuted}>
                      {member.company || 'Not provided'}
                    </td>
                    <td style={styles.td}>
                      {member.ndaRequired ? (
                        <span style={styles.badgeRequired}>Required</span>
                      ) : (
                        <span style={styles.badgeNA}>N/A (Owner)</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* NDA System Architecture */}
        <div style={styles.infoSection}>
          <h2 style={styles.infoTitle}>NDA System Architecture</h2>
          <div style={styles.infoGrid}>
            <div style={styles.infoItem}>
              <p style={styles.infoItemLabel}>Storage</p>
              <p style={styles.infoItemValue}>
                Supabase Auth user_metadata.nda_signed_at with localStorage fallback for offline resilience.
              </p>
            </div>
            <div style={styles.infoItem}>
              <p style={styles.infoItemLabel}>Cross-App</p>
              <p style={styles.infoItemValue}>
                NDA signed on ANY app carries to ALL apps via shared Supabase auth. One signature covers the entire platform.
              </p>
            </div>
            <div style={styles.infoItem}>
              <p style={styles.infoItemLabel}>Onboarding Flow</p>
              <p style={styles.infoItemValue}>
                Login &rarr; Password Change &rarr; NDA Signature &rarr; Tutorial &rarr; App Access
              </p>
            </div>
            <div style={styles.infoItem}>
              <p style={styles.infoItemLabel}>Apps Protected</p>
              <p style={styles.infoItemValue}>
                All 21 web apps are protected by the NDA gate. No team member can access app features without signing.
              </p>
            </div>
          </div>
        </div>

        {/* How It Works */}
        <div style={styles.howItWorksSection}>
          <h2 style={styles.infoTitle}>How It Works</h2>
          <ul style={styles.stepList}>
            <li style={styles.stepItem}>
              <div style={styles.stepNumber}>1</div>
              <div style={styles.stepText}>
                <span style={styles.stepTextBold}>Team member logs in</span> using their personal or company email with the temporary password provided in their onboarding email.
              </div>
            </li>
            <li style={styles.stepItem}>
              <div style={styles.stepNumber}>2</div>
              <div style={styles.stepText}>
                <span style={styles.stepTextBold}>Password change is required</span> on first login. The team member sets a new secure password along with their phone number and address.
              </div>
            </li>
            <li style={styles.stepItem}>
              <div style={styles.stepNumber}>3</div>
              <div style={styles.stepText}>
                <span style={styles.stepTextBold}>NDA signature page appears.</span> The team member must read and digitally sign the Non-Disclosure Agreement. This step cannot be bypassed or skipped.
              </div>
            </li>
            <li style={styles.stepItem}>
              <div style={styles.stepNumber}>4</div>
              <div style={styles.stepText}>
                <span style={styles.stepTextBold}>App tutorial plays</span> to familiarize the team member with the platform features and navigation.
              </div>
            </li>
            <li style={styles.stepItem}>
              <div style={styles.stepNumber}>5</div>
              <div style={styles.stepText}>
                <span style={styles.stepTextBold}>Full app access is granted.</span> The NDA signature timestamp is stored in Supabase Auth user_metadata, so signing once grants access across all Mt Forge apps.
              </div>
            </li>
          </ul>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <p style={styles.footerText}>
            Mt Forge &mdash; 121 Rainbow Falls Bay, Alberta
          </p>
        </div>
      </div>
    </div>
  );
}

export default NDATrackerPage;
